import React, {Component} from 'react'
import {Query, Mutation} from 'react-apollo'
import PropTypes from 'prop-types'
import {
    Modal,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Input,
    Button
} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'


import projectClientInvoiceQuery from '../../../queries/server/project_client_invoice'
import upsertInvoicesQuery from '../../../queries/server/mutations/upsert_project_client_invoices'
import {toast} from "react-toastify";

const {format} = Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
})

export default class ProjectInvoiceCreditNoteModal extends Component {

    state = {
        breakdown: {}
    }

    render() {

        const {invoice_id, isOpen, toggle, onSave} = this.props

        if (!invoice_id) return null

        return (
            <Query query={projectClientInvoiceQuery} variables={{id: invoice_id}}>

                {({data, loading, error}) => {

                    if (loading) return null

                    return (
                        <Mutation mutation={upsertInvoicesQuery}>
                            {(upsertInvoicesQueryFunc, mutation) => (
                                <Modal isOpen={isOpen} toggle={toggle} size="lg">
                                    <ModalHeader>Credit Note for
                                        Invoice: {data.project_client_invoice.invoice_number}</ModalHeader>
                                    <ModalBody>
                                        {data.project_client_invoice.breakdown.map(bd => (
                                            <div
                                                className="d-flex flex-row justify-content-between align-items-center pb-3">
                                                <div
                                                    className="d-flex flex-row align-items-center justify-content-between pr-3"
                                                    style={{flex: 9}}>
                                                    <span style={{fontSize: '14px'}}>{bd.description}: </span>
                                                    <span style={{fontSize: '14px'}}>{format(bd.amount)}</span>
                                                </div>
                                                <Input
                                                    style={{flex: 3}}
                                                    size="sm"
                                                    type="number"
                                                    placeholder="e.g. -20"
                                                    onChange={(evt) => {
                                                        const {breakdown} = this.state
                                                        let newBreakdown = {...breakdown}

                                                        newBreakdown[bd.id] = {
                                                            parent_breakdown_id: bd.id,
                                                            description: bd.description,
                                                            amount: evt.target.value,
                                                            project_activity_budget_id: bd.project_activity_budget_id
                                                        }

                                                        this.setState({breakdown: newBreakdown})
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button
                                            size="sm"
                                            color="success"
                                            disabled={mutation.loading}
                                            onClick={() => {

                                                const {project_client_invoice} = data

                                                const {breakdown} = this.state
                                                const newBreakdown = Object.keys(breakdown)
                                                    .filter(key => {
                                                        return parseFloat(breakdown[key].amount) < 0
                                                    })
                                                    .map(key => {
                                                        return breakdown[key]
                                                    })

                                                const creditNote = {
                                                    client_id: project_client_invoice.client.client_id,
                                                    project_id: project_client_invoice.project.project_id,
                                                    type_id: 2,
                                                    parent_invoice_id: project_client_invoice.id,
                                                    breakdown: newBreakdown
                                                }

                                                console.log(creditNote)

                                                upsertInvoicesQueryFunc({variables: {data:[creditNote]}})
                                                    .then(() => {
                                                        if(onSave) onSave()
                                                        toast.success('Credit Note Added', {autoClose: 2000})
                                                    })
                                                    .catch(e => toast.error(e.message, {autoClose: false}))


                                            }}
                                        >
                                            <FontAwesomeIcon
                                                color="#fff"

                                                spin={mutation.loading}
                                                icon={mutation.loading ? 'spinner' : 'save'}/>{' '}
                                            {(mutation.loading) ? 'Saving...' : 'Save'}
                                        </Button>
                                    </ModalFooter>
                                </Modal>
                            )}
                        </Mutation>
                    )

                }}

            </Query>
        )

    }

}

ProjectInvoiceCreditNoteModal.propTypes = {
    onSave: PropTypes.func,
    isOpen: PropTypes.bool,
    toggle: PropTypes.func,
    invoice_id: PropTypes.number.isRequired
}